/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenu_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespAppliedFilters_itemSearch" | "SbSharedRefineMenuFilters_itemSearch" | "SbSharedRefineMenuDisplayPrefsSelect_itemSearch">;
    readonly " $refType": "SbRespRefineMenu_itemSearch";
};
export type SbRespRefineMenu_itemSearch$data = SbRespRefineMenu_itemSearch;
export type SbRespRefineMenu_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenu_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenu_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespAppliedFilters_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilters_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDisplayPrefsSelect_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = '09b670ab8ef3af2b6168c20764b9fdd7';
export default node;
